<template>
  <b-row>
    <b-col sm="12">
      <my-card title="Daftar Jenis Biaya">
        <template slot="button">
          <button-add v-if="cP(49)" :to="{name: 'expenses-add'}" variant="primary"></button-add>
        </template>
        <template slot="body">
          <data-tables ref="datatables" endpoint="v1/expenses" :fields="fields">
            <template v-slot:1="{item}">
              <span :class="{'font-weight-bolder': !item[6], 'ml-1':item[6]}">{{item[6] ? '-' : ''}} {{item[1]}}</span>
            </template>
            <template v-slot:3="{item}">
              {{item[3] | formatNumber}}
            </template>
            <template v-slot:4="{item}">
              <b-badge variant="light-primary" v-if="item[4]==1">Ya</b-badge>
              <b-badge variant="light-warning" v-else>Tidak</b-badge>
            </template>
            <template v-slot:5="{item}">
              <div class="float-none">
                <button-link v-if="cP(50)" size="sm" :to="{name:'expenses-edit',params:{id: item[5]}}" feather-icon="EditIcon"></button-link>
                <button-delete v-if="cP(51)" @ondelete="deleteRow" :id="item[5]" :name="`${item[0]} (${item[1]})`"></button-delete>
              </div>
            </template>
          </data-tables>
        </template>
      </my-card>
    </b-col>
  </b-row>
</template>

<script>
import ButtonAdd from '@/my-components/ButtonAdd.vue'
import DataTables from '@/my-components/DataTables.vue'
import ButtonDelete from '@/my-components/ButtonDelete.vue'
import ButtonLink from '@/my-components/ButtonLink.vue'
import {BBadge} from 'bootstrap-vue'

export default {
  components:{
    ButtonAdd,
    DataTables,
    ButtonDelete,
    ButtonLink,
    BBadge
  },
  data() {
    return {
      fields: {
        0:{sortable: true, searchable: true, label:'Kode'},
        1:{sortable: true, searchable: true, label:'Nama Biaya'},
        2:{sortable: true, searchable: true, label:'Pemasok Default'},
        3:{sortable: true, searchable: true, label:'Standart Biaya'},
        4:{sortable: true, searchable: true, label:'Aktif'},
        5:{sortable: false, searchable: false, label:''},
      }
    }
  },
  methods:{
    async deleteRow(payload){
      try {
        await this.$store.dispatch('expenses/destroy',payload)
        this.$refs.datatables.refresh()
        this.toastSuccess("OK","Data Berhasil Dihapus!")
      } catch (error) {
        this.handleError(error)
      }
    }
  }
}
</script>

<style>

</style>